export namespace UcEvent {
    export const REFERRAL_LIMIT_CHANGED: string = 'event-referral-limit-changed';
    export const QUOTE_REFERRAL_FLAG_CHANGED: string = 'event-quote-referral-flag-changed';
    export const SCHEME_RESET: string = 'event-scheme-reset';
    export const REFERRAL_CHANGED: string = 'event-referral-changed';
    export const BUSINESS_TYPE_MODAL_CLOSED: string = 'business-type-modal-closed';

    export const QUICK_QUOTE_MODAL_CLOSE = 'qq-modal-close';
}
